import { createSlice }    from '@reduxjs/toolkit';
import * as salesReducers from 'Redux/Reducers/Sales';

export interface ISalesState {
  openRequests: string[],
  failedRequests: string[],
  updatedAt: number,
  entries: {
    days: {
      ymd: string,
      count: number,
      total: string,
      netto: string,
      status: string
    }[],
    dau: { statDate: string, count: number }[],
    wau: { statDate: string, count: number }[],
    mau: { statDate: string, count: number }[],
  },
}

export const salesSlice = createSlice({
  name: 'sales',
  initialState: {
    openRequests: [],
    failedRequests: [],
    entries: {
      days: [],
      dau: [],
      wau: [],
      mau: [],
    },
    updatedAt: 0,
  },
  reducers: salesReducers,
});
